module.exports = "/images/vendor/flag-icon-css/flags/4x3/hu.svg?0d7409f88bca8325938e46e3ef672716";